import React, {useEffect, useState} from "react";
import {getCompanyNotes, saveClientNote, saveCompanyNote} from "../common/api/WebApi";
import {Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import {formatDate, formatDateTime} from "../common/Utils";
import {Chip} from "@mui/material";
import ClientNoteModal from "../client/ClientNoteModal";
import MDButton from "../../components/MDButton";
import Divider from "@mui/material/Divider";

export default function CompanyNotes({guid}) {

  const [addNote, setAddNote] = useState(false);
  const [manageNote, setManageNote] = useState(false);

  const [note, setNote] = useState(null);
  const [notes, setNotes] = useState([]);
  const [saving, setSaving] = useState(false);
  const [searchNotes, setSearchNotes] = useState(null);
  const [modalActive, setModalActive] = useState(false);

  const highlight = (haystack) => {
    const needle = searchNotes;
    if (!needle) {
      return haystack;
    }
    var querystr = needle;
    var result = haystack;
    var reg = new RegExp(querystr.split(' ').join('|'), 'gi');
    var final_str = result.replace(reg, function (str) {
      return '<b>' + str + '</b>'
    });

    return final_str;

  }

  const matchNotes = (note) => {
    let notes = searchNotes.split(' ');
    let match = true;
    notes.forEach(n => {
      let fam = '';
      if (fam.toLowerCase().includes(n.toLowerCase())) {
        match = true;
      } else if (!note.note.toLowerCase().includes(n.toLowerCase())) {
        match = false;
      }
    });
    return match;
  }

  const getNotesFn = () => {
    getCompanyNotes(guid).then((resp) => {
      setNotes(resp);
    })
  }
  useEffect(() => {
    getNotesFn();
  }, [guid])

  const handleSaveNote = async (note) => {

    setSaving(true);
    note.companyGuid = guid;

    let result = await saveCompanyNote(note);
    setSaving(false);
    setAddNote(false);
    setManageNote(false);

    getNotesFn();
  }

  const NoteItem = ({note, index}) => {
    return (<li
      className={'list-group-item hover-bg-soft'}
      key={index}>
      <p>
        <span
          dangerouslySetInnerHTML={{__html: highlight(note.note)}}/>
      </p>
      <Chip
        label={<>
          {!note.pinned ?
            <span
              style={{
                transform: 'rotate(15deg)'
              }}
              className="font-color-grey fa fa-thumbtack"></span>
            :
            <span
              className="font-color-gold fa fa-thumbtack"></span>
          }</>}
        variant="outlined"
      />
      &nbsp;
      <Chip
        label={<>By: {note.createUser.firstName + ' ' + note.createUser.lastName} On: {formatDateTime(note.createDate)}</>}
        variant="outlined"
      />&nbsp;
      {note.reminderNote && <>
        <Chip
          label={<>Reminder Date: {formatDate(note.reminderDate)}</>}
          variant="outlined"
        />&nbsp;
      </>
      }
    </li>);
  }

  return (
    <div>
      <h5>Company Notes
        <MDButton
          color="secondary"
          size="small"
          className={'pull-right'}
          onClick={() => {
            setAddNote(true)
          }}>
          <span className={'fa fa-plus'}></span>&nbsp;Add note
        </MDButton>
        <input type={'text'} className={'form-control form-control-sm my-n1 mx-2 pull-right w-25'}
               placeholder={'Search Notes'}
               onFocus={(e) => {
                 setModalActive(true);
               }}
               onBlur={(e) => {
                 setModalActive(false);
               }}
               onChange={(e) => {
                 setSearchNotes(e.target.value);
               }}/>
      </h5>
      <Divider/>

      <Row style={{
        'clear': 'both',
        'maxHeight': '500px',
        'overflow': 'auto'
      }}>

        {notes?.length > 0 && <>
          <Col sm={12}>

            <ul className={'list-group'}>
              {notes?.length === 0 && <li className={'list-group-item'}>
                <center>No company notes</center>
              </li>
              }

              {notes?.sort((a, b) => a.createDate - b.createDate).filter((a) => a.pinned).map((note, index) => {
                  return (
                    <NoteItem note={note} key={index} index={index}/>
                  )
                }
              )}

              {notes?.sort((a, b) => a.createDate - b.createDate).filter((a) => !!!a.pinned).map((note, index) => {
                  return (
                    <NoteItem note={note} key={index} index={index}/>
                  )
                }
              )}

            </ul>

          </Col>
        </>}
      </Row>

      {
        (addNote || manageNote) && <ClientNoteModal
          key={note?.guid}
          note={manageNote}
          show={manageNote || addNote}
          saving={saving}
          handleClose={() => {
            setManageNote(false);
            setAddNote(false)
            setNote(null);
          }}
          handleSave={handleSaveNote}/>
      }

    </div>
  )
}